import { useMemo, useCallback } from 'react';

import { HostSystem } from 'constants/HostSystem';

export const useHostSystems = () => {
  const hostSystems: HostSystem[] = useMemo(
    () => [
      HostSystem.UCS,
      HostSystem.UBS,
      HostSystem.WBS,
      HostSystem.TFF,
      HostSystem.ALB,
      HostSystem.CAN2,
      HostSystem.CAN1,
      HostSystem.MIRAKL,
    ],

    []
  );

  const getLabel = useCallback((val: string) => {
    switch (val) {
      case HostSystem.UCS:
        return 'Conventional';
      case HostSystem.UBS:
        return 'Natural East';
      case HostSystem.WBS:
        return 'Natural West';
      case HostSystem.TFF:
        return "Tony's Fine Foods";
      case HostSystem.ALB:
        return "Albert's";
      case HostSystem.CAN2:
        return 'Canada East';
      case HostSystem.CAN1:
        return 'Canada West';
      case HostSystem.MIRAKL:
        return 'Mirakl';
      default:
        return val;
    }
  }, []);

  return { hostSystems, getLabel };
};
